import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {newsletterTemplateEdit_template} from "../components/templates/newsletterTemplateEdit_template";

declare var ko: any;
declare var page: any;

export class newsletter_template_edit extends vnModule_knockoutJS {

    protected newsletterTemplateEditTemplate: newsletterTemplateEdit_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {

        this.newsletterTemplateEditTemplate = new newsletterTemplateEdit_template("newsletterTemplateEdit_template", this.viewModel, this);
        return [this.newsletterTemplateEditTemplate.build()];
    }

    protected getModuleName(): string {

        return "newsletterTemplateEdit_template";
    }

    public fillPage(): void {

        this.getNewsletterTemplateReferences();
    }

    protected getNewsletterTemplateReferences() {

        // LOADING : starts
        this.loadingIn(this.newsletterTemplateEditTemplate.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/references';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onNewsletterTemplateReferenceRequestReturn;
        this.XHRHdl.execute();
    }

    protected onNewsletterTemplateReferenceRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.newsletterTemplateEditTemplate.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterTemplateEditTemplate.setPermissions(responseParsed.permissions);
                obj.setColorOptions(responseParsed.colors);
                obj.newsletterTemplateEditTemplate.setLogoUrls(responseParsed.headerLogos);
                obj.newsletterTemplateEditTemplate.setSenders(responseParsed.senders);
                obj.getNewsletterTemplateDataForEdit();
            });
        };
    }

    protected setColorOptions(colors) {

        let headerColorOptions = colors.slice(); 

        headerColorOptions.unshift({'id':null,'name':'None'});
        this.newsletterTemplateEditTemplate.setHeaderColors(headerColorOptions);

        let sidebarBackgroundColorOptions = colors.slice();

        sidebarBackgroundColorOptions.unshift({'id':null,'name':'None'});
        this.newsletterTemplateEditTemplate.setSidebarBackgroundColors(sidebarBackgroundColorOptions);

        colors.unshift({'id':null,'name':'Select An Option'});
        this.newsletterTemplateEditTemplate.setContentPrimaryColors(colors);
        this.newsletterTemplateEditTemplate.setContentSecondaryColors(colors);
    }

    protected getNewsletterTemplateDataForEdit() {

        this.loadingIn(this.newsletterTemplateEditTemplate.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetNewsletterTemplateDataForEdit;
        this.XHRHdl.execute();

    }

    protected onGetNewsletterTemplateDataForEdit(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setNewsletterTemplateData(responseParsed.template);
            });
            obj.loadingOut(obj.newsletterTemplateEditTemplate.builtTemplate);
        };
    }

    protected setNewsletterTemplateData(template) {

        this.newsletterTemplateEditTemplate.setId(template.id);
        this.newsletterTemplateEditTemplate.setName(template.name);
        this.newsletterTemplateEditTemplate.setSenderName(template.senderName);
        this.newsletterTemplateEditTemplate.setUtmSource(template.utmSource);
        this.newsletterTemplateEditTemplate.setIsEmails(template.isEmails);
        this.newsletterTemplateEditTemplate.setIsInteractionEmails(template.isInteractionEmails);
        this.newsletterTemplateEditTemplate.setIsLoginSystemEmails(template.isLoginSystemEmails);
        this.newsletterTemplateEditTemplate.setIsBannerImageFullWidth(template.isBannerImageFullWidth);
        this.newsletterTemplateEditTemplate.setIncludeSendDateUnderHeader(template.includeSendDateUnderHeader);

        let headerColor = template.headerColor;
        if(headerColor){
            this.newsletterTemplateEditTemplate.headerColorSelector.setSelectedOption(headerColor.id);
            this.newsletterTemplateEditTemplate.setColor(headerColor.value);
        }

        let headerLogo = template.headerLogo;
        if(headerLogo){
            this.newsletterTemplateEditTemplate.headerLogoSelector.setSelectedOption(headerLogo.id);
            this.newsletterTemplateEditTemplate.setLogo(headerLogo.value);
        }
        
        let primaryColor = template.primaryColor;
        if(primaryColor){
            this.newsletterTemplateEditTemplate.contentPrimaryColorSelector.setSelectedOption(primaryColor.id);
        }
        
        let secondaryColor = template.secondaryColor;
        if(secondaryColor){
            this.newsletterTemplateEditTemplate.contentSecondaryColorSelector.setSelectedOption(secondaryColor.id);
        }

        let sidebarBackgroundColor = template.sidebarBackgroundColor;
        if(sidebarBackgroundColor){
            this.newsletterTemplateEditTemplate.sidebarBackgroundColorSelector.setSelectedOption(sidebarBackgroundColor.id);
        }
        
        let sender = template.sender;
        if(sender){
            this.newsletterTemplateEditTemplate.senderEmailSelector.setSelectedOption(sender.id);
        }


    }

    
    public cancelForm() {

        this.onClickCancelEdit();
    }

    public onClickCancelEdit() {

        let brandId = this.getVnAppZone().app.params.idBrand;
        page.redirect("/brand/" + brandId + "/newsletter/templates/");
    }

    protected save(type) {

        this.loadingIn(this.newsletterTemplateEditTemplate.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/newsletter/templates/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.newsletterTemplateEditTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveReturn;
        XHRHdl.execute();
    }

    protected onSaveReturn (req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                if (req.request.status === 200) {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Newsletter Template saved !");
                    obj.redirectToNewsletterTemplateList();
                }

            });
            obj.loadingOut(obj.newsletterTemplateEditTemplate.builtTemplate);

        };
    }

    protected redirectToNewsletterTemplateList(){

        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + "/newsletter/templates/");
    }

    public filterDropdownOnChange(idElement){

        if(idElement == 'headerColorSelector') {
            let options = this.newsletterTemplateEditTemplate.headerColorSelector.getTemplateViewModel().options();
            let id = this.newsletterTemplateEditTemplate.headerColorSelector.getTemplateViewModel().selectedOption();
            let selectedOption =  options.find(option => option.id == id);
            if(selectedOption){
                this.newsletterTemplateEditTemplate.setColor(selectedOption.value);
            }
        }
        
        if(idElement == 'headerLogoSelector') {
            let options = this.newsletterTemplateEditTemplate.headerLogoSelector.getTemplateViewModel().options();
            let id = this.newsletterTemplateEditTemplate.headerLogoSelector.getTemplateViewModel().selectedOption();
            let selectedOption =  options.find(option => option.id == id);
            if(selectedOption){
                this.newsletterTemplateEditTemplate.setLogo(selectedOption.value);
            }
        }
    }

}


// WEBPACK FOOTER //
// ./js/modules/newsletter_template_edit.ts